export const RESPONSIVE_CONTAINER_HEIGHT = {
    L: 746,
    M: 550,
    S: 360,
};
